<ion-chip [ngClass]="selected ? 'selected': ''">
  <span *ngIf="icon"
        class="material-symbols-outlined icon-small text-neutral-500 pr-xs">{{ icon }}</span>
  <span class="ts-small">{{ label }}</span>
</ion-chip>
